import removeImage from './removeImage';
import removeCompetition from './removeCompetition';

export default {
  removeImage,
  removeCompetition,
};
